import { render } from "./colorpicker.vue?vue&type=template&id=364ab7ae&scoped=true"
import script from "./colorpicker.vue?vue&type=script&lang=js"
export * from "./colorpicker.vue?vue&type=script&lang=js"

import "./colorpicker.vue?vue&type=style&index=0&id=364ab7ae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2729008182/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364ab7ae"]])

export default __exports__